import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import MatomoConsent from './MatomoConsent';
import config from '../config';
import './Footer.scss'

export default function Footer({
  ...props
}) {
  const [ showConsent, setShowConsent ] = useState(false);
  const { trackLink }                   = useMatomo();

  function outlink(link) {
    trackLink({href: link, linkType: 'link'});
    window.location = link;
  }

  function outlinkButton(link, text, className = "px-0 py-0 footer-link") {
    return (
      <Button
        className={className}
        variant="link" 
        onClick={() => outlink(link)}
        href={link}
      >
      {text}
      </Button>
    );
  }

  return (
    <footer className="footer">
      <div className = "cfs-footer text-grey pt-4 mt-4">
        <div className="container">
          <Row className="d-flex">
            <Col sm={4}>
              <p><strong>Cookies</strong></p>
              <p>
                <Button
                  className="px-0 py-0 footer-link"
                  variant="link"
                  onClick={() => setShowConsent(true)}
                >
                  Manage&nbsp;consent
                </Button><br/>
                <MatomoConsent
                  externalOpen={showConsent}
                  setExternalOpen={setShowConsent}
                />
              </p>
              <p><strong>Governance Documentation</strong></p>
                <p>
                  {outlinkButton(config.links.governance, "Corporate Governance")}<br/>
                  {outlinkButton(config.links.accounts, "Latest Annual Report & Accounts")}<br/>
                  {outlinkButton(config.links.cookies, "Cookie Notice")}<br/>
                  {outlinkButton(config.links.complaints, "Complaints Procedure")}<br/>
                  {outlinkButton(config.links.slavery, "Modern Slavery Statement")}<br/>
                  {outlinkButton(config.links.privacy, "Privacy Policy")}<br/>
                </p>
            </Col>
            <Col sm={4}>
              <p><strong>Contact Us</strong></p>
              <p>
                Cirencester Friendly<br/>
                Mutuality House<br/>
                The Mallards<br/>
                South Cerney<br/>
                Gloucestershire<br/>
                GL7 5TQ<br/>
              </p>
              <p>
                <strong>Tel:</strong> 01285 652492<br/>
              </p>
            </Col>
  
            <Col sm={4} className="justify-content-end">
              <p>
                <strong>Office hours:</strong> 8:45am - 5pm, Monday - Friday<br/>
                (excluding Public Holidays)
              </p>
              <p>
                <strong>Telephone hours:</strong> 9am - 5pm, Monday, Tuesday, Wednesday and Friday and 10am - 5pm Thursdays. (excluding Public Holidays)
              </p>
            </Col>
          </Row>
          <p className="footer text-left mt-5 smallprint">
            Cirencester Friendly is a trading name of Cirencester Friendly Society Limited. Registered and incorporated under the Friendly Societies Act 1992. Reg. No. 149F.<br/>
			      Cirencester Friendly Society Limited is Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority under registration number 109987.<br/>
		        You can confirm our registration on the {
              outlinkButton(
                "https://www.fca.org.uk",
                "FCA's website.",
                "smallprint text-left px-0 footer-link"
              )
            }<br/>
		        Cirencester Friendly is not responsible for the content of external websites.
          </p>
        </div>
      </div>  
    </footer>
  )

}